export default {"src":"/_next/static/media/horizontal-dots-white.5d814f1e.svg","height":2,"width":176};